export enum LeadView {
  TABLE = "table",
  BOARD = "board",
}
